import { primaryGrey, neturalBlack, netural400 } from "../../constants/color";

/**
 * A white card section used throughout the reward wheel pages.
 * Provides consistent padding, border, border-radius, and optional title.
 */
const WheelSectionCard = ({ title, subtitle, children, style = {} }) => (
  <div
    style={{
      backgroundColor: "#fff",
      borderRadius: "12px",
      border: `1px solid ${primaryGrey}`,
      padding: "20px",
      marginBottom: "20px",
      ...style,
    }}
  >
    {title && (
      <label
        style={{
          fontSize: "14px",
          fontWeight: "700",
          color: neturalBlack,
          marginBottom: subtitle ? "4px" : "16px",
          textTransform: "uppercase",
          display: "block",
        }}
      >
        {title}
      </label>
    )}
    {subtitle && (
      <label
        style={{
          fontSize: "13px",
          color: netural400,
          marginBottom: "16px",
          display: "block",
        }}
      >
        {subtitle}
      </label>
    )}
    {children}
  </div>
);

export default WheelSectionCard;
